'use strict';

const BossProjectile = require('../entities/boss-projectile');

class BossProjectilePool {
  constructor(capacity, profile) {
    this.capacity = capacity || 240;
    this.limit = this.capacity;
    this.profile = profile || null;
    this.items = Array.from({ length: this.capacity }, () => new BossProjectile());
  }

  setLimit(limit) {
    this.limit = Math.max(1, Math.min(this.capacity, 300, Math.floor(Number(limit) || 1)));
  }

  setProfile(profile) {
    this.profile = profile || null;
  }

  activeCount() {
    return this.items.reduce((count, projectile) => count + (projectile.active ? 1 : 0), 0);
  }

  spawn(options) {
    if (this.activeCount() >= this.limit) return null;
    const projectile = this.items.find((item) => !item.active);
    if (!projectile) return null;
    const source = options || {};
    const profile = source.profile || this.profile || {};
    const baseSpeed = Math.max(0, Number(source.speed) || 0);
    const speed = source.speedIsFinal
      ? baseSpeed
      : baseSpeed * Math.max(0.3, Number(profile.speedMultiplier) || 1);
    return projectile.reset({ ...source, profile, speed });
  }

  update(dt, bounds, target) {
    const splits = [];
    this.items.forEach((projectile) => {
      const request = projectile.update(dt, bounds, target);
      if (request && request.count > 0) splits.push(request);
    });
    splits.forEach((request) => {
      const count = Math.max(1, Math.min(8, request.count));
      const spread = Math.PI * 0.82;
      for (let index = 0; index < count && this.activeCount() < this.limit; index += 1) {
        const offset = count === 1 ? 0 : -spread / 2 + (spread * index) / (count - 1);
        this.spawn({
          x: request.x,
          y: request.y,
          heading: request.heading + offset,
          speed: request.speed * 0.82,
          speedIsFinal: true,
          radius: Math.max(6, request.radius * 0.74),
          profile: request.profile,
          motionKey: index % 2 ? 'arc' : 'straight',
          curveRate: (index % 2 ? 1 : -1) * 0.34,
          splitDisabled: true
        });
      }
    });
  }

  draw(ctx) {
    this.items.forEach((projectile) => projectile.draw(ctx));
  }

  getActive() {
    return this.items.filter((projectile) => projectile.active);
  }

  clear() {
    this.items.forEach((projectile) => { projectile.active = false; });
  }
}

module.exports = BossProjectilePool;
